import { render, staticRenderFns } from "./DetailConfiguration.vue?vue&type=template&id=18c0950c"
import script from "./DetailConfiguration.vue?vue&type=script&lang=js"
export * from "./DetailConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports